import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/quality-assurance/mantenimiento-qms")({
  beforeLoad: () => { throw redirect({ to: "/es/servicios/quality-assurance/implementacion-qms", statusCode: 301 }); },
});

